import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const cofenseTriage = defineConnector({
  identifier: "cofenseTriage",
  name: "Cofense Triage",
  tagLine: "Phishing email triage and response",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: ({ host }) => domainToRegex(host),
  auth: oauthAuth,
  steps: [
    {
      title: "Create API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "In Cofense Triage, go to **Administration › API Management**, open the **Version 2** tab, and create a new application. Copy the generated client ID and client secret — the secret is shown only once.",
        },
      ],
    },
    {
      title: "Enter your details",
      items: [
        {
          kind: "hostname",
          label: "Triage host",
          required: true,
          placeholder: "triage.example.com",
          helperText: "Your Cofense Triage appliance hostname.",
          target: { kind: "configuration", field: "host" },
        },
        {
          kind: "input",
          label: "Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "client_credentials",
    tokenEndpoint: ({ host }) => `https://${host}/oauth/token`,
    scopes: () => [],
    clientCredentialsFrom: "db",
    tokenEndpointAuthMethod: () => "client_secret_post",
  },
  connectionTest: {
    protocol: "http",
    request: ({ host }) => `https://${host}/api/public/v2/system/status`,
  },
});
